export default {
  // MfaSetting
  userAdd: 'Add User',
  selectDelete: 'Delete Selected',
  modifyBtn: 'Edit',
  userName: 'Username',
  userNumber: 'User ID',
  userEmail: 'User Email',
  registrationDate: 'First Registered Date & Time',
  state: 'Application Status',
  userDelete: 'Delete User',
  alertMsg: 'Please select an item to delete.',
  deleteMsg: 'Do you want to delete this user?',
  userRegisterMsg: 'User has been registered.',
  userUpdaterMsg: 'User information has been updated.',
  userEnabledMsg: 'User has been set to inactive.',
};
